import { Button, Link } from "@mui/material";
import image1 from "assets/image/new feautre/full/featureimage1.png";
import image2 from "assets/image/new feautre/full/featureimage2.png";
import ReactGA from "components/ReactGA";

export const listFeature = (t, handleContact, handleClose) => [
  {
    id: 1,
    // title: t("newFeature:full.whiteness1.title"),
    title: t("newFeature:full.whiteness1.title"),
    image: image1,
    content: (
      <>
        <div>
          {t("newFeature:full.whiteness1.content")}
          <Button
            sx={{ padding: 0, textDecoration: "underline" }}
            onClick={() => {
              handleClose();
              handleContact();
              ReactGA.event("click_navigation", {
                component: "navbar",
                link: "contact",
              });
            }}
          >
            {t("newFeature:full.whiteness1.clickHere")}
          </Button>
        </div>
      </>
    ),
  },
  {
    id: 2,
    title: t("newFeature:full.whiteness2.title"),
    image: image2,
    content: (
      <div>
        <div>{t("newFeature:full.whiteness2.content.0")}</div>
        <li>{t("newFeature:full.whiteness2.content.1")}</li>
        <li>{t("newFeature:full.whiteness2.content.2")}</li>
      </div>
    ),
  },
];
